<template>
  <div class="nuttrema-overlay-youtube-button">
    <el-button @click="toggleOverlay" type="text">
      <i class="fas fa-play" style="margin-right: 0.5em"></i> {{ anchor }}
    </el-button>
    <nuttrema-dialog
      :visible.sync="show"
      :append-to-body="true">
      <overlay-page @close="closeOverlay" :file="file" :title="title"></overlay-page>
    </nuttrema-dialog>
  </div>
</template>

<script>
import OverlayPage from 'components/pages/professional/shared/youtube/page-youtube-overlay';
import NuttremaDialog from 'components/ui/overlay/nuttrema-dialog';

export default {
  name: 'nuttrema-overlay-youtube-button',
  components: {
    OverlayPage,
    NuttremaDialog,
  },
  props: {
    file: {
      type: String,
      required: true,
      default: null,
    },
    anchor: {
      type: String,
      required: false,
      default: null,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    toggleOverlay() {
      this.show = !this.show;
    },
    closeOverlay() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-overlay-youtube-button {
    float: right;
    margin-right: 0.75em;
    .el-button {
      padding: 0;
      color: #607d8b;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/overlay/nuttrema-overlay-youtube-button.vue